module.exports = __webpack_public_path__ + "static/media/ppe_fac_pro.abcaac98.png";